import withTrackOnMount from "theme/modules/Analytics/withTrackOnMount";

export default () =>
  withTrackOnMount({
    event: "Product Viewed",
    isResolvedFromProps: (props) => !props.loading && props.product,
    shouldUpdateEvent: () => false,
    mapPropsToProperties: (props) => {
      const finalPrice = props.product?.prices?.finalPrice?.priceInclTax?.value;
      return {
        sku: props.product.sku,
        name: props.product.name,
        price: finalPrice?.amount,
        currency: finalPrice?.currency,
      };
    },
  });
